module.exports = __webpack_public_path__ + "static/media/Lens-Sweet_HK.607f71ee.png";